export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Cloudflare dev tunnels follow the convention dev<N>.thetaassist.ai (e.g. dev3.thetaassist.ai).
// Match strictly on that convention so production tenants on thetaassist.ai
// (app., uat., customer subdomains) are NOT treated as dev environments.
export const cloudflareDevTunnelPattern = /^dev\d+\.thetaassist\.ai$/i;

const isAzureDevTunnel =
    typeof window !== 'undefined'
        ? window.location.hostname.endsWith('.devtunnels.ms')
        : false;

const isCloudflareDevTunnel =
    typeof window !== 'undefined'
        ? cloudflareDevTunnelPattern.test(window.location.hostname)
        : false;

const isDevTunnel = isAzureDevTunnel || isCloudflareDevTunnel;

const isLocalOrDevEnvironment = isLocalhost || isDevTunnel;

export default isLocalOrDevEnvironment;
